import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LanguageProvider, usePageTranslations } from './contexts/LanguageContext';
import Header from './components/Layout/Header';
import Footer from './components/Layout/Footer';
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import GalleryPage from './pages/GalleryPage';
import FAQPage from './pages/FAQPage';
import CustomRequestPage from './pages/CustomRequestPage';
import ContactPage from './pages/ContactPage';
import LegalPage from './pages/LegalPage';
import AdminPage from './pages/AdminPage';
import TirePage from './pages/TirePage';
import CookieConsent from './components/CookieConsent/CookieConsent';
import { Toaster } from 'react-hot-toast';
import { usePageTracking } from './hooks/useAnalytics';

// Composant qui gère le chargement des traductions de page
const AppContent: React.FC = () => {
  const { isPageLoading } = usePageTranslations();
  
  // Track page views automatically
  usePageTracking();

  return (
    <>
      <Header />
      <main>
        {isPageLoading && (
          <div className="fixed top-24 left-0 right-0 bg-red-600 text-white px-4 py-2 text-center text-sm z-40">
            <div className="flex items-center justify-center space-x-2">
              <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
              <span>Chargement des traductions...</span>
            </div>
          </div>
        )}
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/pneus" element={<TirePage />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/custom-request" element={<CustomRequestPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/legal" element={<LegalPage />} />
          <Route path="/admin" element={<AdminPage />} />
          {/* Language routes */}
          <Route path="/:lang" element={<HomePage />} />
          <Route path="/:lang/services" element={<ServicesPage />} />
          <Route path="/:lang/pneus" element={<TirePage />} />
          <Route path="/:lang/gallery" element={<GalleryPage />} />
          <Route path="/:lang/faq" element={<FAQPage />} />
          <Route path="/:lang/custom-request" element={<CustomRequestPage />} />
          <Route path="/:lang/contact" element={<ContactPage />} />
          <Route path="/:lang/legal" element={<LegalPage />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
};

function App() {
  return (
    <Router>
      <LanguageProvider>
        <div className="App">
          <AppContent />
          <Toaster 
            position="top-right"
            toastOptions={{
              duration: 4000,
              style: {
                background: '#000000',
                color: '#ffffff',
                borderLeft: '4px solid #E30613'
              }
            }}
          />
          <CookieConsent />
        </div>
      </LanguageProvider>
    </Router>
  );
}

export default App;